/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ChevronLeftIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Chevron Left',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m12.2373,16.45508c-.19629,0-.39355-.07715-.54004-.23047l-5.4873-5.70312c-.28027-.29004-.28027-.74902,0-1.03906l5.5-5.7168c.28711-.29883.7627-.30762,1.05957-.02051.29883.28711.30859.76172.02051,1.05957l-4.99902,5.19727,4.98633,5.18359c.28809.29785.27832.77246-.02051,1.05957-.14453.14062-.33203.20996-.51953.20996Z"
      fill="currentColor"
    />
  </svg>`;
};
